import { Injectable } from '@angular/core';
import {CompanyUser} from "../../features/users/model/entities";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, interval, Observable, startWith, Subscription, takeWhile} from "rxjs";
import {switchMap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private currentUserSubject: BehaviorSubject<CompanyUser | null> = new BehaviorSubject<CompanyUser | null>(null);
  public currentUser$: Observable<CompanyUser | null> = this.currentUserSubject.asObservable();
  private refreshIntervalSeconds = (environment?.currentUserRefreshSeconds ?? 30 ) * 1000;
  private refreshSubscription: Subscription | null = null;
  private isActive = true;
  get active(): boolean {
    return this.isActive
  }

  set active(isActive: boolean) {
    this.isActive = isActive;
    if(!isActive) {
      if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
        this.refreshSubscription = null;
        this.currentUserSubject.next(null);
      }
    } else {
      this.startAutoRefresh();
    }
  }
  constructor(private http: HttpClient) {
    this.currentUser$.subscribe((user) => {
      this.permissions = this.calculatePermissions()
    })
  }

  // Avvia l'aggiornamento periodico
  private startAutoRefresh(): void {
    if(!this.refreshSubscription) {
      this.refreshSubscription = interval(this.refreshIntervalSeconds)
        .pipe(
          startWith(0), // Esegui immediatamente al primo avvio
          takeWhile(() => this.isActive),
          switchMap(() => this.fetchCurrentUser())
        )
        .subscribe({
          next: (user) => this.currentUserSubject.next(user),
          error: (err) => console.error('Errore durante l\'aggiornamento dell\'utente:', err)
        });
    }
  }

  // Recupera l'utente corrente dal backend
  private fetchCurrentUser(): Observable<CompanyUser> {
    return this.http.get<CompanyUser>(`${environment.apiUrl}/user`);
  }

  // Metodo per ottenere l'utente corrente (sync)
  public get currentUserValue(): CompanyUser | null {
    return this.currentUserSubject.value;
  }

  // Verifica se l'utente ha un determinato permesso
  hasPermission(permission: string): boolean {
    return this.permissions?.includes(permission) || this.permissions?.includes('*') || false;
  }

  // Verifica se l'utente ha almeno uno dei permessi specificati
  hasAnyPermission(permissions: string[]): boolean {
    return permissions.some(permission => this.hasPermission(permission));
  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
      this.refreshSubscription = null;
    }
  }


  private rolePermissions: { [key: string]: string[] } = {
    "ADMIN": ['*'],
    "CO": ['general','rescue','restore'],
    "DRIVER": []
  }
  private permissions: string[] | null = null;

  private calculatePermissions(): string[] {


    // Se non c'è utente, svuota cache e restituisci array vuoto
    if (!this.currentUserValue) {
      return [];
    }

    // Calcola i permessi
    const permissions = this.currentUserValue.rolesIds
      ?.flatMap(role => this.rolePermissions[role] || [])
      .filter((perm, index, arr) => arr.indexOf(perm) === index) || [];

    return permissions;
  }

  // // Forza l'aggiornamento manuale
  // refreshUserData(): void {
  //   this.fetchCurrentUser().subscribe({
  //     next: (user) => this.currentUserSubject.next(user),
  //     error: (err) => console.error('Errore durante l\'aggiornamento manuale:', err)
  //   });
  // }
}
